import PropTypes from 'prop-types'

import {Badge, BADGE_DESIGNS, BADGE_INTENTS, BADGE_SIZES} from '@adv-mt/ui/badge'

const SellerPackBadge = ({pack}) => {
  if (!pack) {
    return null
  }

  return (
    <Badge design={BADGE_DESIGNS.SOFT} intent={BADGE_INTENTS.PRIMARY} size={BADGE_SIZES.SMALL}>
      {pack}
    </Badge>
  )
}

SellerPackBadge.displayName = 'SellerPackBadge'

SellerPackBadge.propTypes = {
  pack: PropTypes.string
}

export default SellerPackBadge
